module.exports = __webpack_public_path__ + "img/7.e8aff8d7.jpg";